import { RefObject, useLayoutEffect, useRef } from 'react';

// Read `.current` only from callbacks and effects: it trails `value` during render.
export const useLatestRef = <T>(value: T): RefObject<T> => {
  const ref = useRef(value);
  useLayoutEffect(() => {
    ref.current = value;
  });
  return ref;
};
